import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import {
  isRequired,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';


export const VoucherTypeForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código" required>
          <Field
            name="voucherCode"
            component={TextInput}
            type="text"
            placeholder="Código"
            validate={[isRequired]}
            />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Mostrar en Página de Pagos">
          <Field
            name="displayInPaymentsPage"
            component='input'
            type="checkbox"
            />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción">
          <Field
            name="description"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.VoucherType.getIn(['current', 'activity']).isEmpty(),
});

VoucherTypeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

VoucherTypeForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'VoucherTypeForm',
})(VoucherTypeForm);

export default connect(mapStateToProps)(formComponent);
